import script from "./ImportBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImportBtn.vue?vue&type=script&lang=ts&setup=true"

import "./ImportBtn.vue?vue&type=style&index=0&id=7f49a32f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f49a32f"]])

export default __exports__